export default __webpack_public_path__ + "static/media/1937.15bc6108.png";